import { FC, SVGAttributes } from 'react';

const FillDate: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M25.4903 31.5H10.5097C8.91585 31.5 7.38725 30.854 6.26021 29.7042C5.13317 28.5544 4.5 26.995 4.5 25.3689V13.5H31.5V25.3689C31.5 26.995 30.8668 28.5544 29.7398 29.7042C28.6127 30.854 27.0841 31.5 25.4903 31.5Z"
        fill="#F6F7F8"
      />
      <path
        d="M31.5 13.5H4.5V10.7609C4.5 9.89603 4.8692 9.06662 5.52636 8.45509C6.18353 7.84356 7.07484 7.5 8.00422 7.5H27.9958C28.9252 7.5 29.8165 7.84356 30.4736 8.45509C31.1308 9.06662 31.5 9.89603 31.5 10.7609V13.5Z"
        fill="#FF7676"
      />
      <path
        d="M23.3882 5.74342C23.3882 5.0567 23.9449 4.5 24.6316 4.5C25.3183 4.5 25.875 5.0567 25.875 5.74342V9.25658C25.875 9.9433 25.3183 10.5 24.6316 10.5C23.9449 10.5 23.3882 9.9433 23.3882 9.25658V5.74342Z"
        fill="#F02828"
      />
      <path
        d="M16.7566 5.74342C16.7566 5.0567 17.3133 4.5 18 4.5C18.6867 4.5 19.2434 5.0567 19.2434 5.74342V9.25658C19.2434 9.9433 18.6867 10.5 18 10.5C17.3133 10.5 16.7566 9.9433 16.7566 9.25658V5.74342Z"
        fill="#F02828"
      />
      <path
        d="M10.125 5.74342C10.125 5.0567 10.6817 4.5 11.3684 4.5C12.0551 4.5 12.6118 5.0567 12.6118 5.74342V9.25658C12.6118 9.9433 12.0551 10.5 11.3684 10.5C10.6817 10.5 10.125 9.9433 10.125 9.25658V5.74342Z"
        fill="#F02828"
      />
      <path
        d="M16.5927 26.2833C16.4139 26.2787 16.2379 26.2378 16.0754 26.1631C15.9129 26.0885 15.7672 25.9816 15.6473 25.8489L11.2183 21.0026C10.9834 20.7451 10.8604 20.4048 10.8764 20.0566C10.8924 19.7084 11.046 19.3808 11.3035 19.1459C11.561 18.9109 11.9013 18.7879 12.2495 18.8039C12.5977 18.8199 12.9253 18.9735 13.1603 19.231L16.6267 23.0382L22.725 16.8888C22.8464 16.7663 22.9907 16.669 23.1497 16.6023C23.3087 16.5355 23.4792 16.5008 23.6517 16.5C23.8241 16.4992 23.995 16.5324 24.1545 16.5976C24.3141 16.6629 24.4593 16.7589 24.5818 16.8803C24.7043 17.0017 24.8016 17.1459 24.8684 17.3049C24.9351 17.4639 24.9698 17.6345 24.9706 17.8069C24.9714 17.9793 24.9382 18.1502 24.873 18.3098C24.8077 18.4694 24.7117 18.6146 24.5903 18.737L17.5211 25.8744C17.4009 26.0004 17.257 26.1014 17.0977 26.1716C16.9384 26.2417 16.7667 26.2797 16.5927 26.2833Z"
        fill="#F02828"
      />
    </svg>
  );
};

export default FillDate;
